export const createOrUpdateMetaTag = (attrName: string, attrValue: string, content?: string | null) => {
  const selector = `meta[${attrName}="${attrValue}"]`;
  const existingTag = document.querySelector(selector);

  if (!content) {
    existingTag?.remove();
    return;
  }

  if (existingTag) {
    if (existingTag.getAttribute('content') !== content) {
      existingTag.setAttribute('content', content);
    }
  } else {
    const newTag = document.createElement('meta');
    newTag.setAttribute(attrName, attrValue);
    newTag.setAttribute('content', content);
    document.head.appendChild(newTag);
  }
};
